import Connector, { takeQuery } from '../../agent';
import types from './types';
import { entityType } from '../../constants';

const CompareRowsModal = {
  getRows: async params => {
    if (entityType.inventoryHist === params.entityType) {
      return Connector.api.post(`/inventories/history/getFullRows`, params.ids);
    } else if (entityType.productHist === params.entityType) {
      return Connector.api.post(`/chemicalProducts/history/getFullRows`, params.ids);
    }
  }
};

const CompareRowsModalSagas = [takeQuery(types.GET_FULL_ROWS, CompareRowsModal.getRows)];

export default CompareRowsModalSagas;
